<template>
  <div
    class="bg-white shadow rounded-lg overflow-hidden cursor-pointer hover:shadow-lg transition-shadow duration-200 flex flex-col h-full relative"
    @click="$emit('show-detail', product)"
  >
    <div class="p-2 flex-1 flex flex-col">
      <!-- Product Image with Out of Stock Overlay -->
      <div class="aspect-square relative mb-2 flex-shrink-0">
        <img
          :src="imageUrl"
          :alt="product.title"
          @error="handleImageError"
          class="object-cover rounded-lg w-full h-full"
          :class="{'opacity-50': isOutOfStock}"
          ref="productImage"
        />
        <!-- Out of Stock Label -->
        <div
          v-if="isOutOfStock"
          class="absolute inset-0 flex items-center justify-center"
        >
          <div class="bg-red-500 text-white px-4 py-2 rounded-lg font-bold transform rotate-[-15deg] shadow-lg">
            BARANG HABIS
          </div>
        </div>
      </div>
    </div>

    <div class="px-2 py-2">
      <div>
        <h3 class="text-sm font-semibold mb-1 line-clamp-2">{{ product.title }}</h3>
        <div class="flex">
          <p class="pk_style" v-if="product.pk_power">{{ product.pk_power }} PK</p>
          <p class="type_style" v-if="product.type?.type_name">{{ product.type.type_name }}</p>
        </div>
        <p class="harga text-base font-bold mt-auto mb-1">Rp {{ formatPrice(product.price) }}</p>
      </div>
      <!-- Seller Info with Profile Picture -->
      <div class="flex items-center gap-2 mb-1">
        <div class="seller-avatar">
          <img
            :src="sellerAvatarUrl"
            :alt="product.user.name"
            @error="handleSellerImageError"
            class="w-8 h-8 rounded-full object-cover border border-gray-200"
          />
        </div>
        <div class="text-xs text-gray-600 flex-1">
          <p><span class="font-medium">Penjual:</span> {{ product.user.name }}</p>
          <p><span class="font-medium">Alamat:</span> {{ product.user.address || '-' }}</p>
        </div>
      </div>
    </div>
    
    <!-- Add to Cart Button -->
    <div class="px-2 py-2 bg-gray-50">
      <button
        class="w-full py-1 px-2 rounded text-xs font-medium focus:outline-none focus:ring-2 focus:ring-blue-500"
        :class="[
          isOutOfStock 
            ? 'bg-gray-400 cursor-not-allowed' 
            : 'bg-blue-500 hover:bg-blue-600 text-white'
        ]"
        @click.stop="$emit('add-to-cart', product)"
        :disabled="isOutOfStock"
      >
        {{ isOutOfStock 
          ? 'Stok Habis' 
          : (isMobile ? '+ Keranjang' : 'Tambah Ke Keranjang') 
        }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductCard',
  props: {
    product: {
      type: Object,
      required: true
    },
    isMobile: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    isOutOfStock() {
      return this.product.stock === 0;
    },
    imageUrl() {
      if (this.product.image?.[0]) {
        return `https://be.ajakstore.com/storage/${this.product.image[0]}`;
      }
      return 'https://placehold.co/200x200/lightgray/white?text=No+Image';
    },
    sellerAvatarUrl() {
      if (this.product.user?.image) {
        return `https://be.ajakstore.com/storage/${this.product.user.image}`;
      }
      return 'https://placehold.co/32x32/lightgray/white?text=User';
    }
  },
  methods: {
    formatPrice(price) {
      return new Intl.NumberFormat('id-ID').format(price);
    },
    handleImageError() {
      if (this.$refs.productImage) {
        this.$refs.productImage.src = 'https://placehold.co/200x200/lightgray/white?text=Error+Loading+Image';
      }
    },
    handleSellerImageError(event) {
      event.target.src = 'https://placehold.co/32x32/lightgray/white?text=User';
    }
  },
  emits: ['show-detail']
}
</script>

<style scoped>
img {
  max-height: 230px;
  object-fit: cover;
}

.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.pk_style {
  border: 1px solid rgb(255, 255, 255);
  border-radius: 7px;
  width: fit-content;
  padding: 0px 12px;
  font-size: 13px;
  color: white;
  background-color: rgb(58, 58, 58);
}

.type_style {
  border: 1px solid rgb(255, 255, 255);
  border-radius: 7px;
  width: fit-content;
  padding: 0px 12px;
  font-size: 13px;
  color: white;
  background-color: rgb(31, 110, 129);
}

.seller-avatar img {
  max-height: none;
}

@media (width <= 760px) {
  img:not(.seller-avatar img) {
    max-height: 80px;
  }
  .harga {
    font-size: 15px;
  }
  .type_style, .pk_style{
    font-size: 11px;
  }
}
</style>